// src/pages/Feedback.jsx
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import bg from '../assets/feedback.png';
import bgDone from '../assets/feedback_done.png'; // 送出成功後的完成圖

export default function Feedback() {
  const [content, setContent] = useState('');
  const [saving, setSaving]   = useState(false);
  const [ok, setOk]           = useState(false);
  const [err, setErr]         = useState('');
  const stageRef = useRef(null);

  useEffect(() => {
    const el = stageRef.current;
    if (!el) return;
    const setK = () => {
      const w = el.clientWidth || 1080;
      el.style.setProperty('--k', String(w / 1080));
    };
    const ro = new ResizeObserver(setK);
    ro.observe(el);
    window.addEventListener('resize', setK);
    window.addEventListener('orientationchange', setK);
    setK();
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', setK);
      window.removeEventListener('orientationchange', setK);
    };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    setSaving(true); setOk(false); setErr('');
    try {
      const resp = await axios.post('/api/sglrt/feedback', { content });
      if (resp?.data?.ok) {
        setOk(true);          // 成功→切換完成狀態
        setContent('');       // 清空文字
      } else {
        setErr('送出失敗，請稍後再試');
      }
    } catch {
      setErr('送出失敗，請稍後再試');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0,
        background: '#eee',
        display: 'grid', placeItems: 'center'
      }}
    >
      <div
        ref={stageRef}
        style={{
          width:  'min(100vw, calc(100vh * 9 / 16))',
          height: 'min(100vh, calc(100vw * 16 / 9))',
          position: 'relative',
          backgroundImage: `url(${ok ? bgDone : bg})`, // 成功後換背景
          backgroundSize: '100% 100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',

          ['--area-left']:   '10%',
          ['--area-top']:    '54.7%',
          ['--area-width']:  '80%',
          ['--area-height']: '30%',
          ['--base-line']:   '56',
          ['--base-font']:   '34',
          ['--k']: 1
        }}
      >
        <style>{`
          @font-face {
            font-family: 'SingHand';
            src: url('/assets/handwrite.ttf') format('truetype');
            font-weight: normal;
            font-style: normal;
            font-display: swap;
          }
        `}</style>

        {!ok && (
          <form
            onSubmit={submit}
            style={{
              position: 'absolute',
              left:   'var(--area-left)',
              top:    'var(--area-top)',
              width:  'var(--area-width)',
              height: 'var(--area-height)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <textarea
              value={content}
              onChange={e => setContent(e.target.value)}
              placeholder="寫下你的回饋 / Write your feedback here…"
              spellCheck={false}
              inputMode="text"
              style={{
                flex: '1 1 auto',
                width: '100%',
                background: 'transparent',
                border: 'none',
                outline: 'none',
                resize: 'none',
                padding: 0,
                fontFamily:
                  "SingHand, 'Patrick Hand', 'Segoe Print', 'DFKai-SB', 'PingFang TC', 'Microsoft JhengHei', cursive",
                fontSize:   'calc(var(--base-font) * var(--k) * 1px)',
                lineHeight: 'calc(var(--base-line) * var(--k) * 1px)',
                letterSpacing: '0.3px',
                color: '#1a1a1a',
              }}
            />

            {/* 送出區：左右置中，往下再移一倍（34 → 68） */}
            <div
              style={{
                position: 'absolute',
                left: 0,
                top: 'calc(100% + calc(110 * var(--k) * 1px))',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 'calc(14 * var(--k) * 1px)',
                zIndex: 2,
                textAlign: 'center',
              }}
            >
              {err && (
                <span style={{ fontSize:'calc(18 * var(--k) * 1px)', color:'#c31b1b', fontWeight:700 }}>
                  {err}
                </span>
              )}

              <button
                type="submit"
                disabled={saving || !content.trim()}
                style={{
                  padding: 'calc(12 * var(--k) * 1px) calc(15 * var(--k) * 1px)',
                  fontSize: 'calc(48 * var(--k) * 1px)',   // 文字再大一點（28 → 34）
                  fontWeight: 800,
                  letterSpacing: '.5px',
                  borderRadius: 'calc(18 * var(--k) * 1px)',
                  border: '1px solid rgba(0,0,0,.25)',
                  background: '#b4967a',     // 保留你目前的顏色設定
                  color: '#efe9e1',
                  boxShadow: '0 6px 12px rgba(0,0,0,.15)',
                  textShadow: 'none',
                  cursor: (saving || !content.trim()) ? 'default' : 'pointer',
                  opacity: (saving) ? 0.7 : 1,
                  transition: 'transform .06s ease, box-shadow .06s ease',
                }}
                onMouseDown={(e) => {
                  if (saving) return;
                  e.currentTarget.style.transform = 'translateY(calc(2 * var(--k) * 1px))';
                  e.currentTarget.style.boxShadow = '0 3px 6px rgba(0,0,0,.18)';
                }}
                onMouseUp={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,.15)';
                }}
                onTouchStart={(e) => {
                  if (saving) return;
                  e.currentTarget.style.transform = 'translateY(calc(2 * var(--k) * 1px))';
                  e.currentTarget.style.boxShadow = '0 3px 6px rgba(0,0,0,.18)';
                }}
                onTouchEnd={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,.15)';
                }}
              >
                {saving ? '送出中…' : '送出 SEND'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
